var map = {
	"./de/btn-detail.png": "ho0x",
	"./en/btn-detail.png": "pjXC",
	"./es/btn-detail.png": "vMR4",
	"./fr/btn-detail.png": "bKxu",
	"./ja/btn-detail.png": "9mcR",
	"./ko/btn-detail.png": "id/b",
	"./pt/btn-detail.png": "ckqu",
	"./ru/btn-detail.png": "Q+K9",
	"./th/btn-detail.png": "1ajt",
	"./zh-Hant/btn-detail.png": "CDnC"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6uyJ";